<template>
  <div>
    <paganationSearch
      v-if="showPaginationTop && totalRows > perPage"
      :allowPaginate="allowPaginate"
      :total="totalRows"
      :total_pages="total_pages"
      :perPage="perPage"
      v-model="page"
      @input="paging"
      class="mb-3"
    />
    <b-table
      outlined
      :dark="dark"
      :hover="hover"
      :striped="striped"
      :small="small"
      :fixed="fixed"
      responsive
      :items="items"
      :fields="fields"
      :current-page="1"
      :per-page="perPage"
      @row-clicked="rowClicked"
      :busy="isBusy"
      stickyColumn="true"
    >
      <template v-slot:head()="data">
        <span
          class="d-flex align-items-center justify-content-start"
          v-if="!data.label"
        >
          <mdicon name="order-numeric-ascending" size="20" />&nbsp;
          <span
            v-if="showCheckBox && showRowAllSelected"
            class="mr-2 text-muted"
          />
          <b-form-checkbox
            v-if="showCheckBox && showRowAllSelected"
            v-model="checkedAll"
            @change="handleCheckedAll"
          />
        </span>
      </template>
      <template v-if="disabledDragRow" v-slot:cell(row)="data">
        <div class="d-flex align-items-center">
          <span
            class="fs_16 font-weight-bold text-muted"
            v-text="(currentPage - 1) * perPage + (data.index + 1)"
          />
          <span
            v-if="showCheckBox && handleCheckBoxCondition(data.item)"
            class="ml-2 text-muted"
          />
          <b-form-checkbox
            v-if="showCheckBox && handleCheckBoxCondition(data.item)"
            v-model="data.item.selected"
            class="ml-2"
            @change="rowSelected(data.item)"
          />
        </div>
      </template>
      <template #cell(show_details)="row">
        <b-button size="sm" @click="toggleCollaps(row)" class="mr-2">
          {{ $lang.person_rel }}
        </b-button>
      </template>
      <template #thead-top="data">
        <b-tr v-if="data">
          <b-th
            class="text-center"
            v-for="(item, index) in itemTopHeader"
            :key="index"
            :colspan="item.colspan"
            :variant="item.variant"
          >
            <span class="text-center">{{ item.name }}</span></b-th
          >
        </b-tr>
      </template>
      <template #row-details="row">
        <slot name="contentCollaps" :row="row" />
      </template>
      <template v-slot:table-busy>
        <div class="bg-white p-3">
          <LoadingSpinner :loading="true" />
        </div>
      </template>
      <template v-slot:cell(quality)="data">
        <span :style="getStyleQuality(data.item.quality)" class="badge">{{
          data.item.quality
        }}</span>
      </template>
      <template v-slot:cell(research_manager.name)="data">
        <ProfileBoxPopupWrapper
          :data="data.item.research_manager"
          deskTopPopupClass="top-245"
          nameClass="color-complementary"
        />
      </template>
      <template v-slot:cell(research_manager.person.full_name)="data">
        <ProfileBoxPopupWrapper
          :data="data.item.research_manager"
          deskTopPopupClass="top-245"
          nameClass="color-complementary"
        />
      </template>
      <template v-slot:cell(researcher.person.full_name)="data">
        <ProfileBoxPopupWrapper
          :data="data.item.researcher"
          deskTopPopupClass="top-245"
          nameClass="color-complementary"
        />
      </template>
      <template v-slot:cell(researcher.name)="data">
        <ProfileBoxPopupWrapper
          :data="data.item.researcher"
          deskTopPopupClass="top-245"
          nameClass="color-complementary"
        />
      </template>
      <template v-slot:cell(audience_fullName)="data">
        <ProfileBoxPopupWrapper
          :data="data.item.audience"
          deskTopPopupClass="top-235"
          nameClass="color-complementary"
        />
      </template>
      <template v-slot:cell(person_fullName)="data">
        <ProfileBoxPopupWrapper
          :data="data.item"
          deskTopPopupClass="top-235"
          nameClass="color-primary text-decoration-underline"
        />
      </template>
      <template v-slot:cell(completer)="data">
        <span
          @click="goToParvandeh(data.item)"
          v-text="pathOr(null, ['manager', 'full_name'], data.item)"
          class="cursor_pointer text-primary"
        />
      </template>
      <template v-slot:cell(parvandeh_full_name)="data">
        <span
          @click="goToParvandeh2(data.item)"
          v-text="pathOr(null, ['parvandeh', 'full_name'], data.item)"
          class="cursor_pointer text-primary"
        />
      </template>
      <template v-slot:cell(public_exam_pack_name)="data">
        <span v-if="handleCheckBoxCondition(data.item)">
          <span
            v-if="
              pathOr(
                false,
                ['exam_pack', 'correction_method_algorithm_id'],
                data.item
              ) && checkFrontPageName(data.item)
            "
            @click="generateReportRoute(data.item)"
            class="cursor_pointer text-primary"
          >
            <span
              v-text="
                `${pathOr(null, ['exam_pack', 'id'], data.item)}- ${pathOr(
                  '',
                  ['exam_pack', 'caption'],
                  data.item
                )}`
              "
              class="cursor_pointer text-primary"
            />
          </span>
          <span
            v-else
            v-text="
              `${pathOr(null, ['exam_pack', 'id'], data.item)}- ${pathOr(
                '',
                ['exam_pack', 'caption'],
                data.item
              )}`
            "
          />
        </span>
        <span
          v-else
          v-text="
            `${pathOr(null, ['exam_pack', 'id'], data.item)}- ${pathOr(
              '',
              ['exam_pack', 'caption'],
              data.item
            )}`
          "
        />
      </template>
      <template v-slot:cell(audience_full_name)="data">
        <ProfileBoxPopupWrapper
          :data="data.item.audience"
          deskTopPopupClass="top-235"
          nameClass="color-complementary"
        />
      </template>
      <template v-slot:cell(amount)="data">
        <div v-text="priceFormat(data.item.amount)" />
      </template>
      <template v-slot:cell(payment_base)="data">
        <div v-text="priceFormat(data.item.payment_base)" />
      </template>
      <template v-slot:cell(working_amount_with_order_unit)="data">
        <span>
          {{ priceFormat(data.item.working_amount) }}
          {{ pathOr("", ["order_unit", "caption"], data.item) }}
        </span>
      </template>
      <template v-slot:cell(working_amount)="data">
        <div v-text="priceFormat(data.item.working_amount)" />
      </template>
      <template v-slot:cell(salary_amount)="data">
        <div v-text="priceFormat(data.item.salary)" />
      </template>
      <template v-slot:cell(sum_creditor)="data">
        <div class="dir_ltr" v-text="priceFormat(data.item.sum_creditor)" />
      </template>
      <template v-slot:cell(sum_debtor)="data">
        <div class="dir_ltr" v-text="priceFormat(data.item.sum_debtor)" />
      </template>
      <template v-slot:cell(remaining)="data">
        <div
          :class="`dir_ltr ${+data.item.remaining < 0 ? 'text-danger' : ''}`"
          v-text="priceFormat(data.item.remaining)"
        />
      </template>
      <template v-slot:cell(register_comment_1)="data">
        <span
          class="text-success cursor_pointer"
          @click="goToRegisterComment1(data.item)"
        >
          <mdicon name="comment-text-outline" size="24" />
        </span>
      </template>
      <template v-slot:cell(register_comment_2)="data">
        <span
          class="text-success cursor_pointer"
          @click="goToRegisterComment2(data.item)"
        >
          <mdicon name="comment-text-outline" size="24" />
        </span>
      </template>
      <template v-slot:cell(exam_pack_confirm_time)="data">
        <span
          class="text-success"
          v-if="data.item.exam_pack_confirm_time"
          v-html="
            `${$lang.confirmed} (${createDateFormat(
              data.item.exam_pack_confirm_time.jalali
            )})`
          "
        />
        <span class="text-danger" v-else>
          {{ $lang.unConfirmed }}
        </span>
      </template>
      <template v-slot:cell(register_comment_3)="data">
        <span
          class="text-success cursor_pointer"
          @click="goToRegisterComment3(data.item)"
        >
          <mdicon name="comment-text-outline" size="24" />
        </span>
      </template>
      <template v-slot:cell(status)="data">
        <b-badge
          :variant="getBadge(data.item.status)"
          class="badge-lightblue"
          >{{ data.item.status }}</b-badge
        >
      </template>
      <template v-slot:cell(competency_count)="data">
        <b-button
          v-if="hasCompetencyCountLink"
          @click="showCompetencyCount(data.item)"
          >{{ data.item.competency_count }}</b-button
        >
        <span v-else>{{ data.item.competency_count }}</span>
      </template>
      <template v-slot:cell(is_systemic_user)="data">
        <i
          v-if="!!data.item.is_systemic_user"
          class="far fa-check-circle fa-lg text-success"
        ></i>
        <i v-else class="far fa-times-circle fa-lg text-danger"></i>
      </template>
      <template v-slot:cell(place_caption)="data">
        <b-button @click="showPlace(data.item)">{{
          data.item.place_caption
        }}</b-button>
      </template>
      <template v-slot:cell(is_confirmed)="data">
        <div v-if="data.item.is_confirmed == 1">
          <i
            class="fa fa-check-circle fa-lg text-success"
            aria-hidden="true"
          ></i>
        </div>
      </template>
      <template v-slot:cell(is_last_job)="data">
        <div v-if="data.item.is_last_job == 1">
          <i
            class="fa fa-check-circle fa-lg text-success"
            aria-hidden="true"
          ></i>
        </div>
      </template>
      <template v-slot:cell(card_no)="data">
        <span dir="ltr">{{ data.item.card_no }}</span>
      </template>
      <template v-slot:cell(question_description)="data">
        <span dir="rtl">{{
          showSomeCharacters(data.item.question_description)
        }}</span>
      </template>
      <template v-slot:cell(rolesString)="data">
        <span dir="rtl">{{ generateRoles(data) }}</span>
      </template>
      <template v-slot:cell(value)="data">
        <i class="fa fa-plus text-success" v-if="data.value.id == '1'"></i>
        <i v-else class="fa fa-minus text-danger"></i>
      </template>
      <template v-slot:cell(show_as_final)="data">
        <div v-if="data.item.show_as_final == 1">
          <i
            class="fa fa-check-circle fa-lg text-success"
            aria-hidden="true"
          ></i>
        </div>
      </template>
      <template v-slot:cell(duration_apply_method)="data">
        <div v-if="data.item.duration_apply_method == 'azmoon'">
          {{ $lang.azmoon }}
        </div>
        <div v-else>
          {{ $lang.question }}
        </div>
      </template>
      <template v-slot:cell(is_enable_second)="data">
        {{ data.item.is_enable ? "فعال" : "غیرفعال" }}
      </template>
      <template v-slot:cell(is_answered)="data">
        <span v-if="data.item.is_answered" class="text-success">
          <mdicon name="check-circle-outline" size="24" />
        </span>
        <span v-else class="text-danger">
          <mdicon name="close-circle-outline" size="24" />
        </span>
      </template>
      <template v-slot:cell(person.full_name)="data">
        <ProfileBoxPopupWrapper
          :data="data.item"
          deskTopPopupClass="top-235"
          nameClass="color-primary text-decoration-underline"
        />
      </template>
      <template v-slot:cell(exercise.name)="data">
        <mdicon
          class="text-danger mr-2"
          v-if="pathOr(false, ['item', 'has_evidence_error'], data)"
          name="alert"
          size="20"
        />
        <span v-text="pathOr('', ['item', 'exercise', 'name'], data)" />
      </template>
      <template v-slot:cell(is_enable_text)="data">
        {{ data.item.is_enable ? "فعال" : "غیرفعال" }}
      </template>
      <template v-slot:cell(is_default_text)="data">
        {{ data.item.is_default ? "بله" : "خیر" }}
      </template>
      <template v-slot:cell(isConfirmed)="data">
        <div class="flex-center">
          <span
            v-if="includes(data.item.parvandeh_code, confirmedLoadingList)"
            class="flex"
          >
            <mdicon name="loading" size="20" class="spinner" />
          </span>
          <b-form-checkbox
            v-else
            ref="isConfirmedReference"
            variant="success"
            class="text-center"
            v-model="data.item.is_confirmed"
            size="lg"
            @change="handleIsConfirmed(data.item)"
          />
        </div>
      </template>
      <template v-slot:cell(is_enable)="data">
        <template v-if="searchMode">
          <div
            class="text-center"
            @click="toggle(data.item)"
            v-show="toggleable"
            v-b-tooltip.hover
            :title="
              data.item.is_enable
                ? $lang.search.enabled_tooltip
                : $lang.search.disabled_tooltip
            "
          >
            <summary>
              <i
                class="fa fa-unlock text-warning fa-lg"
                v-if="data.item.is_enable"
              ></i>
              <i class="fa fa-lock text-warning fa-lg" v-else></i>
            </summary>
          </div>
        </template>
        <template v-else>
          <span v-if="data.item.is_enable">{{
            $lang.search.enabled_tooltip
          }}</span>
          <span v-else>{{ $lang.search.disabled_tooltip }}</span>
        </template>
      </template>
      <template v-slot:cell(button)="data" v-if="!readOnly">
        <div
          :class="
            availableButtons(data.item).length ? 'd-block d-md-none' : 'd-none'
          "
        >
          <b-dropdown variant="primary" left class="mr-1">
            <template slot="button-content">
              <i class="fa fa-bars"></i>
            </template>
            <b-dropdown-item
              v-for="(button, index) in availableButtons(data.item)"
              :key="index"
              @click="
                button.hasConfirm
                  ? showButtonConfirm(button, data.item)
                  : button.click(data.item)
              "
            >
              <span v-if="button && typeof button.iconFont === 'object'">
                <mdicon
                  :name="pathOr('', ['iconFont', 'name'], button)"
                  :size="pathOr('20', ['iconFont', 'size'], button)"
                  :class="pathOr('', ['iconFont', 'class'], button)"
                />
                <small class="font-weight-bold" v-text="button.text" />
              </span>
              <span v-if="button && typeof button.iconFont === 'string'">
                <i :class="button.iconFont" />
                <small class="font-weight-bold" v-text="button.text" />
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div
          :class="{ 'd-none d-md-block': availableButtons(data.item).length }"
        >
          <div class="d-flex justify-content-center">
            <div
              class="dynamicButtonGenerated"
              v-for="(button, index) in availableButtons(data.item)"
              :key="index"
            >
              <div class="ml-3 dynamic-buttons">
                <div
                  @click="
                    button.hasConfirm
                      ? showButtonConfirm(button, data.item)
                      : button.click(data.item)
                  "
                  v-if="button"
                  class="list-unstyled cursor-pointer"
                  v-b-tooltip.hover.bottom
                  :title="button.tooltip || button.text"
                >
                  <mdicon
                    v-if="typeof button.iconFont === 'object'"
                    :name="pathOr('', ['iconFont', 'name'], button)"
                    :size="pathOr('20', ['iconFont', 'size'], button)"
                    :class="pathOr('', ['iconFont', 'class'], button)"
                  />
                  <i v-else :class="button.iconFont" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:cell(term_by_id)="data">
        {{ pathOr(null, ["item", "term", "id"], data) }}-
        {{ pathOr(null, ["item", "term", "caption"], data) }}
      </template>
      <template v-slot:cell(no_begin_research_count)="data">
        <b-button
          v-b-tooltip.hover
          title="جهت مشاهده تحقیق‌های بدون اقدام این پرونده کلیک نمائید"
          variant="secondary"
          v-text="pathOr(null, ['no_begin_research_count', 'count'], data.item)"
          @click="countClicked(data.item, 'no_begin_research_count')"
        />
      </template>
      <template v-slot:cell(current_research_count)="data">
        <b-button
          v-b-tooltip.hover
          title="جهت مشاهده تحقیق‌های در جریان این پرونده کلیک نمائید"
          variant="secondary"
          v-text="pathOr(null, ['current_research_count', 'count'], data.item)"
          @click="countClicked(data.item, 'current_research_count')"
        />
      </template>
      <template v-slot:cell(semi_completed_research_count)="data">
        <b-button
          v-b-tooltip.hover
          title="جهت مشاهده تحقیق‌های اتمام ناقص این پرونده کلیک نمائید"
          variant="secondary"
          v-text="
            pathOr(null, ['semi_completed_research_count', 'count'], data.item)
          "
          @click="countClicked(data.item, 'semi_completed_research_count')"
        />
      </template>
      <template v-slot:cell(complete_research_count)="data">
        <b-button
          v-b-tooltip.hover
          title="جهت مشاهده تحقیق‌های کامل این پرونده کلیک نمائید"
          variant="secondary"
          v-text="pathOr(null, ['complete_research_count', 'count'], data.item)"
          @click="countClicked(data.item, 'complete_research_count')"
        />
      </template>
      <template v-slot:cell(all_research_count)="data">
        <b-button
          v-b-tooltip.hover
          title="جهت مشاهده کل تحقیق‌های این پرونده کلیک نمائید"
          variant="secondary"
          v-text="pathOr(null, ['all_research_count', 'count'], data.item)"
          @click="countClicked(data.item, 'all_research_count')"
        />
      </template>
    </b-table>

    <paganationSearch
      v-if="totalRows > perPage"
      :allowPaginate="allowPaginate"
      :total="totalRows"
      :total_pages="total_pages"
      :perPage="perPage"
      v-model="page"
      @input="paging"
    />
    <confirm
      v-if="buttonClicked && buttonClickedItem"
      :title="buttonClicked.confirmTitle"
      :description="buttonClicked.confirmDescription"
      v-model="showButtonConfirmModal"
      dynamicClass=""
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="buttonClicked.click(buttonClickedItem)"
      @cancel="showButtonConfirmModal = false"
    />
  </div>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import paganationSearch from "@/components/base/paganationSearch";
import confirm from "@/components/base/confirm";
import LoadingSpinner from "./LoadingSpinner";
import { pathOr, includes } from "ramda";
import {
  priceFormat,
  isAdmin,
  goToRoute,
  checkFrontPageName,
  generateError,
  createDateFormat,
} from "@/shared/utils";

export default {
  name: "search-data-component",
  // inheritAttrs: false,
  props: {
    dynamicButtons: {
      type: [Array, Function],
      default: () => [],
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    caption: {
      type: String,
      default: "Table",
    },
    hover: {
      type: Boolean,
      default: false,
    },
    showPaginationTop: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    searchMode: {
      type: Boolean,
      default: true,
    },
    removable: {
      type: Boolean,
      default: false,
    },
    toggleable: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: [Array, Function],
      default: () => [],
    },
    fields: {
      type: [Array, Object],
      default: () => [],
    },
    perPage: {
      type: Number,
      default: 5,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    modify: {
      type: Function,
      default: () => [],
    },
    remove: {
      type: Function,
      default: () => {},
    },
    toggle: {
      type: Function,
      default: () => [],
    },
    changePage: {
      type: Function,
      default: () => [],
    },
    currentPage: {
      type: [Number, String],
      default: 1,
    },
    totalRows: {
      type: Number,
      default: 1,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    allowPaginate: {
      type: Boolean,
      default: true,
    },
    total_pages: {
      type: [String, Number],
      defualt: 0,
    },
    allowRow: {
      type: Boolean,
      default: false,
    },
    editTitle: {
      type: String,
      default: "",
    },
    removeTitle: {
      type: String,
      default: "",
    },
    permissionButtons: {
      type: Array,
      default: () => [],
    },
    itemTopHeader: {
      type: Array,
      default: () => [],
    },
    disabledDragRow: {
      type: Boolean,
      default: true,
    },
    hasCompetencyCountLink: {
      type: Boolean,
      default: true,
    },
    showCheckBox: {
      type: Boolean,
      default: false,
    },
    handleCheckBoxCondition: {
      type: Function,
      default: () => {},
    },
    showRowAllSelected: {
      type: Boolean,
      default: true,
    },
    otherData: {
      type: [Object, Array, String],
      default: null,
    },
    isConfirmedFn: {
      type: Function,
      default: null,
    },
  },
  components: {
    paganationSearch,
    confirm,
    LoadingSpinner,
    ProfileBoxPopupWrapper,
  },
  data() {
    return {
      page: this.currentPage,
      defaultButtons: [
        {
          id: "0",
          name: "active", // new active or deactive
          iconFont: "fa fa-lock text-danger fa-lg",
          text: this.$lang.search.enable_tooltip,
          AllowPermissions: ["admin", "edit"],
          click: this.toggle,
        },
        {
          id: "0",
          name: "enable", // فعال و غیر فعال
          iconFont: "fa fa-lock text-warning fa-lg",
          text: this.$lang.search.enable_tooltip,
          AllowPermissions: ["admin", "edit"],
          click: this.toggle,
        },

        {
          id: "1",
          name: "edit", // ویرایش
          iconFont: "fa fa-edit text-success fa-lg",
          text: this.$lang.search.edit_tooltip,
          AllowPermissions: ["admin", "edit"],
          click: this.modify,
        },
        {
          id: "40",
          name: "editView", //  حالت‌های خاص نمایش
          iconFont: "fa fa-eye text-success fa-lg",
          text: this.$lang.editView,
          AllowPermissions: ["admin", "edit", "view"],
          click: this.modify,
        },

        {
          id: "2",
          name: "delete", //حذف
          text: this.$lang.search.remove_tooltip,
          iconFont: "fas fa-times text-danger fa-lg",
          AllowPermissions: ["admin"],
          click: this.remove,
        },

        {
          id: "3",
          name: "view", //نمایش
          text: this.$lang.show,
          iconFont: "fa fa-eye fa-lg text-success",
          AllowPermissions: ["view"],
          click: this.modify,
        },
        {
          id: "4",
          name: "userRole", // نقش کاربر
          text: this.$lang.add_user_role_tooltip,
          iconFont: "fa fa-id-badge fa-lg text-primary",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "5",
          text: this.$lang.assign_role,
          name: "assignRole", //سطح دسطرسی
          iconFont: "fa fa-id-card-o text-info",
          AllowPermissions: ["admin"],
        },

        {
          id: "6",
          text: this.$lang.role_users,
          name: "user", // کاربران
          iconFont: "fa fa-user fa-lg text-primary",
          click: this.roleUsers,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "7",
          text: this.$lang.search.clone_tooltip,
          name: "clone", //کپی
          iconFont: "fa fa-clone fa-lg text-secondary ",
          click: this.cloneRole,
          AllowPermissions: ["admin"],
        },
        {
          id: "8",
          name: "addIndicator", // ثبت نشانگر
          text: this.$lang.authentication_indicator,
          iconFont: "fa fa-plus fa-lg text-success",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "8",
          name: "addIndicator", // ثبت نشانگر
          text: this.$lang.authentication_indicator,
          iconFont: "fa fa-plus fa-lg text-success",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "9",
          name: "assessmentPlan", // داده برنامه ارزیابی
          iconFont: "fa fa fa-table fa-lg text-info",
          text: this.$lang.search.add_data_tooltip,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "10",
          name: "excelExport", // خروجی اکسل
          iconFont: "fas fa-file-excel fa-lg text-warning",
          text: this.$lang.search.excel_export,
          AllowPermissions: ["admin"],
        },
        {
          id: "11",
          name: "endCenter", // اتمام کانون
          iconFont: "fas fa-stop-circle fa-lg text-danger",
          text: this.$lang.search.end_center_tooltip,
          AllowPermissions: ["admin"],
        },
        {
          id: "12",
          name: "washup",
          iconFont: "far fa-id-badge fa-lg text-success",
          text: this.$lang.search.washup_tooltip,
          AllowPermissions: ["admin", "edit", "view"],
        },
        // {
        //   id: "13",
        //   name: "executing", // در حال اجرا
        //   iconFont: "fa fa-forward fa-lg text-warning",
        //   text: this.$lang.search.executing_tooltip,
        //   AllowPermissions: ["admin", "edit"]
        // },
        {
          id: "14",
          name: "creatingCase", //ساخت پرونده
          iconFont: "fas fa-file-invoice fa-lg text-success",
          text: this.$lang.search.creating_case_tooltip,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "15",
          name: "visitCases", //مشاهده پرونده‌ها
          iconFont: "fa fa-folder fa-lg text-info",
          text: this.$lang.search.visit_cases_tooltip,
          AllowPermissions: ["admin", "edit", "view"],
        },
        {
          id: "16",
          name: "returnToEditing", //حذف پرونده‌ها و ویرایش کانون
          iconFont: "fas fa-share-square rotateY fa-lg text-danger",
          text: this.$lang.search.return_to_editing_tooltip,
          AllowPermissions: ["admin"],
        },
        {
          id: "17",
          name: "exerciseAlgorithm", //الگوریتم تمرین
          text: this.$lang.search.exercise_algorithm_tooltip,
          iconFont: "fa fa-circle fa-lg text-info",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "18",
          name: "insertExerciseDetail", // ویرایش / درج جزء الگوریتم
          text:
            this.$lang.search.edit_tooltip +
            " / " +
            this.$lang.search.insert_exercise_detail_tooltip,
          iconFont: "fa fa-edit fa-lg text-success",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "19",
          name: "competencyIndicators", //درج/ویرایش نشانگر
          text: this.$lang.template_competency_indicators_tooltip,
          iconFont: "fa fa-plus fa-lg text-primary",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "20",
          name: "searchCompetencies", //شایستگی‌ها
          iconFont: "fa fa-file fa-lg text-info",
          text: this.$lang.search.competencies_tooltip,
          AllowPermissions: ["admin", "edit", "view"],
        },
        {
          id: "21",
          name: "confirm", // ارسال پرونده کانون
          iconFont: "fa fa-check-circle fa-lg text-success",
          text: this.$lang.case_confirm,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "22",
          iconFont: "fas fa-reply-all fa-lg text-danger",
          name: "reject", //بازگشت پرونده
          text: this.$lang.search.reject_tooltip,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "23",
          iconFont: "fa fa-history fa-lg text-warning",
          name: "viewHistory", //// تاریخچه عملیات وشایستگی‌های پرونده‌های کانون
          text: this.$lang.search.view_history_tooltip,
          AllowPermissions: ["admin"],
        },
        {
          id: "24",
          name: "scoring", //امتیاز
          iconFont: "fa fa-edit fa-lg text-info",
          text: this.$lang.search.scoring_tooltip,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "25",
          name: "evidence", //مصداق
          iconFont: "fa fa fa-map fa-lg text-info",
          text: this.$lang.search.evidence_tooltip,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "25",
          name: "fileSend", //ارسال پرونده
          iconFont: "fa fa-paper-plane fa-lg text-warning",
          text: this.$lang.fileSend,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "26",
          name: "reports", //گزارشات
          iconFont: "fa fa-print fa-lg text-success",
          text: this.$lang.reports,
          AllowPermissions: ["admin", "edit", "view"],
        },
        {
          id: "27",
          name: "design_exam_pack", // طراحی بسته سوال
          iconFont: "fas fa-plus  fa-lg  text-success ",
          text: this.$lang.design_question_tooltip,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "28",
          name: "justShow", //نمایش
          text: this.$lang.show,
          iconFont: "fa fa-eye fa-lg text-success",
          AllowPermissions: ["admin", "edit"],
          click: this.modify,
        },
        {
          id: "29",
          name: "key", //تغییر پسورد
          text: this.$lang.key,
          iconFont: "fa fa-key fa-lg text-success",
          AllowPermissions: ["admin", "edit"],
          click: this.modify,
        },
        {
          id: "30",
          name: "presence_absence", //حضوریا غیبت
          text: this.$lang.key,
          iconFont: "fa fa-key  fa-lg text-success",
          AllowPermissions: ["admin", "edit"],
          click: this.modify,
        },
        {
          id: "31",
          name: "play_azmoon_execute", // اجرای آزمون
          text: this.$lang.play_azmoon_execute,
          iconFont: "fas fa-play-circle  fa-lg text-success",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "32",
          name: "design", //  طراحی
          iconFont: "fa fa-plus  fa-lg  text-success ",
          text: this.$lang.exercise_evidance,
          AllowPermissions: ["admin", "edit"],
        },

        {
          id: "33",
          name: "calendar", //  برنامه زمان بندی
          iconFont: "fa fa-calendar  fa-lg  text-info ",
          text: this.$lang.execute_plan,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "34",
          name: "sample_evidence", //  شاهد رفتاری
          iconFont: "fa fa-odnoklassniki  fa-lg  text-info ",
          text: this.$lang.sample_evidence,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "35",
          text: this.$lang.confirm_senior_master,
          name: "acceptMaster", //تایید مصاحبه
          iconFont: "fas fa-vote-yea  fa-lg  text-info",
          AllowPermissions: ["edit", "admin"],
        },
        {
          id: "36",
          name: "determination", //  طراحی
          iconFont: "fas fa-user-plus fa-lg  text-info ",
          text: this.$lang.interview_location_plan_audience,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "37",
          name: "userGraduate", //  طراحی
          iconFont: "fas fa-user-graduate fa-lg  text-info ",
          text: this.$lang.determination_master_interview,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "38",
          name: "views_all_azmoon_exampack", //  نمایش لینک‌های آزمون
          iconFont: "fas fa-file-alt fa-lg  text-info ",
          text: this.$lang.views_all_azmoon_exampack,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "38",
          name: "person_relation", //
          iconFont: "fas fa-users fa-lg  text-info ",
          text: this.$lang.person_relation,
          AllowPermissions: ["admin", "edit", "view"],
        },
        {
          id: "39",
          name: "virtual_interview_url", //  نمایش لینک‌های خارجی
          iconFont: "fas fa-link fa-lg  text-info ",
          text: this.$lang.virtual_interview_url,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "40",
          name: "userSecret", //  نمایش لینک‌های خارجی
          iconFont: "fab fa-expeditedssl fa-lg  text-danger ",
          text: this.$lang.get_temporary_password,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "40",
          name: "fileExport", // خروجی اکسل
          iconFont: "fas fa-file-export fa-lg  text-info ",
          AllowPermissions: ["admin"],
        },
        {
          id: "50",
          name: "exportMainDownload", // دانلود خروجی اکسل
          iconFont: "fas fa-download fa-lg text-success",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "51",
          name: "termRegisterCode",
          text: this.$lang.add_code,
          iconFont: "fas fa-qrcode fa-lg text-primary ",
          AllowPermissions: ["admin"],
        },
        {
          id: "52",
          name: "termRegisterCodeDelete",
          text: this.$lang.search.remove_tooltip,
          iconFont: "fas fa-times text-danger fa-lg",
          AllowPermissions: ["admin"],
          click: this.remove,
        },
        {
          id: "53",
          name: "searchesDelete",
          text: this.$lang.search.remove_tooltip,
          iconFont: "fas fa-times text-danger fa-lg",
          AllowPermissions: ["admin"],
          click: this.remove,
        },
        {
          id: "54",
          name: "acceptPersonIdentity",
          text: this.$lang.accept_change_person_identity,
          iconFont: "fa fa-check-circle fa-lg text-success",
          AllowPermissions: ["admin"],
        },
        {
          id: 55,
          name: "changeAssessment", // تغییر برنامه ارزیابی
          text: this.$lang.changeAssessmentPlan,
          iconFont: "fa fa-history fa-lg text-primary",
          AllowPermissions: ["admin"],
        },
        {
          id: 56,
          name: "set_absent", //ثبت غیبت
          text: this.$lang.set_absent,
          iconFont: "fas fa-cloud-upload-alt text-success fa-lg",
          AllowPermissions: ["admin"],
        },
        {
          id: 57,
          name: "upload_ready_report", //آپلود گزارش‌های آماده
          text: this.$lang.upload_ready_report,
          iconFont: "fas fa-times text-danger fa-lg",
          AllowPermissions: ["admin"],
        },
        {
          id: 58,
          name: "selectExamPack",
          text: this.$lang.select_exam_pack,
          iconFont: "fa fa-calendar-check text-primary fa-lg",
          AllowPermissions: ["admin"],
        },
        {
          id: 59,
          name: "showTimeControl",
          text: this.$lang.changeExtraTime,
          iconFont: "fa fa-calculator text-primary fa-lg",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: 60,
          name: "changeStatus",
          text: this.$lang.change_status,
          iconFont: "fa fa-retweet text-primary fa-lg",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: 61,
          name: "moveToFinalReport",
          text: this.$lang.move_to_final_report,
          iconFont: "fa fa-user-plus text-primary fa-lg",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: 62,
          name: "default",
          text: this.$lang.default,
          AllowPermissions: ["admin"],
        },
        {
          id: 63,
          name: "submitStartDelay",
          text: this.$lang.default,
          AllowPermissions: ["admin", "edit"],
        },
      ],
      itemDrag: {},
      buttonClicked: null,
      buttonClickedItem: null,
      showButtonConfirmModal: false,
      checkedAll: false,
      items: [...this.tableData],
      confirmedLoadingList: [],
    };
  },
  watch: {
    currentPage(newValue, oldValue) {
      this.page = newValue;
    },
    items: {
      immediate: true,
      handler(value) {
        this.checkedAll = value.every((item) => item.selected);
      },
    },
  },
  methods: {
    pathOr,
    includes,
    priceFormat,
    isAdmin,
    goToRoute,
    checkFrontPageName,
    createDateFormat,
    showPlace(row) {
      this.$emit("showPlace", row);
    },
    toggleCollaps(row) {
      this.$emit("toggleCollaps", row);
    },
    showSomeCharacters(text) {
      const count = 20;
      return text.slice(0, count) + (text.length > count ? "..." : "");
    },
    showCompetencyCount(item) {
      this.$emit("showCompetencyCount", item);
    },
    availableButtons(item) {
      const generateButtons =
        typeof this.dynamicButtons === "object"
          ? this.dynamicButtons
          : this.dynamicButtons(item);

      return generateButtons
        .filter((button) => {
          let defaultButton = this.defaultButtons.find(
            (x) => x.name === button.name
          );
          defaultButton = {
            ...defaultButton,
            ...button,
          };

          // check permissions
          const buttonPermissions = pathOr(
            [],
            ["AllowPermissions"],
            defaultButton
          );
          return isAdmin(buttonPermissions, this.permissionButtons);
        })
        .map((but) => {
          const showIcon = pathOr(true, ["showIcon"], but);
          if (!showIcon) return;
          const temp = { ...but, show: true };
          const permission = this.defaultButtons.find(
            (x) => x.name === but.name
          );

          if (permission.name == "enable") {
            temp.iconFont =
              item.is_enable == 1
                ? "fa fa-unlock text-success fa-lg"
                : "fa fa-lock text-danger fa-lg";
            temp.text =
              item.is_enable == 1
                ? this.$lang.search.enabled_tooltip
                : this.$lang.search.disabled_tooltip;
          }
          if (permission.name == "presence_absence") {
            temp.iconFont =
              item.is_absent == 1
                ? "fas fa-user-circle text-success fa-lg"
                : "fa fa-user-times text-danger fa-lg";
            temp.text =
              item.is_absent == 1 ? this.$lang.presence : this.$lang.absence;
          }
          if (permission.name == "set_absent") {
            temp.iconFont =
              item.is_absent === 1
                ? "fas fa-user-circle text-success fa-lg"
                : "fa fa-user-times text-danger fa-lg";
            temp.text =
              item.is_absent === 1
                ? this.$lang.set_present
                : this.$lang.set_absent;
          }
          if (permission.name === "active") {
            temp.iconFont = !item.is_enable
              ? temp.deActiveIcon
              : temp.activeIcon;
            temp.text = !item.is_enable ? temp.activeText : temp.deActiveText;
            temp.confirmTitle = !item.is_enable ? "فعال کردن" : "غیرفعال کردن";
            temp.confirmDescription = !item.is_enable
              ? temp.deActiveTextConfirm
              : temp.activeTextConfirm;
          }
          if (permission.name === "exportMainDownload") {
            // check if export record status is done
            temp.show = pathOr(false, ["export_status", "id"], item) === 3;
          }
          if (permission.name === "termRegisterCode") {
            // check if register_by_code is true
            temp.show = pathOr(false, ["register_by_code"], item);
          }
          if (permission.name === "termRegisterCodeDelete") {
            // check if register_by_code is true
            temp.show = !pathOr(null, ["parvandeh_number"], item);
          }
          if (permission.name === "searchesDelete") {
            // show if research_status_id is not in 3,4
            temp.show = !includes(
              pathOr(null, ["research_status", "id"], item),
              [3, 4]
            );
          }
          if (permission.name === "acceptPersonIdentity") {
            // check if person_main_data_status_id is 1
            temp.show =
              pathOr(null, ["person_main_data_status", "id"], item) === 1;
          }
          /* guidance: fitler buttons just show option is true */
          if (temp.show) {
            return {
              ...permission,
              ...temp,
            };
          }
        });
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getStyleQuality(quality) {
      let style = {
        color: "white",
      };
      if (quality == "متوسط") {
        // style.color = "black";
        // style.backgroundColor = "#10ff003d";
        style.backgroundColor = "#53ff1c";
      } else if (quality == "خوب") {
        style.backgroundColor = "#4dbd74";
      } else if (quality == "بد") style.backgroundColor = "#f32c9d";

      return style;
    },
    rowClicked(item) {
      this.$emit("row-clicked", item);
    },
    rowSelected(item) {
      this.checkedAll = this.items.every((item) => item.selected);
      this.$emit("rowSelected", item, (key, value) => {
        item[key] = value;
      });
    },
    handleCheckedAll(selected) {
      this.items = this.items.map((item) => {
        return {
          ...item,
          selected,
        };
      });
      this.$emit("rowAllItems", this.items);
      this.$emit(
        "rowAllSelected",
        this.items.filter((item) => !!item.selected)
      );
    },
    paging(page) {
      this.page = page;
      this.changePage(page);
    },
    generateRoles(data) {
      return pathOr([], ["item", "role_object"], data)
        .map((x) => x.name)
        .join("، ");
    },
    showButtonConfirm(button, item) {
      this.buttonClicked = button;
      this.buttonClickedItem = item;
      this.showButtonConfirmModal = true;
    },
    countClicked(item, countKey) {
      this.$emit("countClicked", item, countKey);
    },
    generateReportRoute(item) {
      const correctionMethodAlgorithmId = pathOr(
        false,
        ["exam_pack", "correction_method_algorithm_id"],
        item
      );
      if (!correctionMethodAlgorithmId)
        return this.$notify.warning("برای این پرسشنامه گزارشی ایجاد نشده است");

      const frontPageName = pathOr(null, ["front_page_name"], item);
      const name = `${frontPageName}-report`;
      const params = {
        parvandehCode: pathOr(null, ["parvandeh", "code"], this.otherData),
        examPackId: pathOr(null, ["exam_pack", "id"], item), // use in azmoon module
        resourceCode: pathOr(null, ["azmoon_execute_person_code"], item), // use in azmoon module
      };
      goToRoute(name, params);
    },
    goToParvandeh(item) {
      const parvandeh_number = pathOr(
        null,
        ["manager", "parvandeh_number"],
        item
      );
      const name = "parvandeh_by_number";
      const params = { parvandeh_number };
      goToRoute(name, params);
    },
    goToParvandeh2(item) {
      const parvandeh_number = pathOr(
        null,
        ["parvandeh", "parvandeh_number"],
        item
      );
      const name = "parvandeh_by_number";
      const params = { parvandeh_number };
      goToRoute(name, params);
    },
    goToRegisterComment1(item) {
      const address = pathOr(null, ["address_object", "0"], item);
      window.open(address, "_blank");
    },
    goToRegisterComment2(item) {
      const address = pathOr(null, ["address_object", "1"], item);
      window.open(address, "_blank");
    },
    goToRegisterComment3(item) {
      const address = pathOr(null, ["address_object", "2"], item);
      window.open(address, "_blank");
    },
    async handleIsConfirmed(item) {
      const id = pathOr(null, ["parvandeh_code"], item);
      const isConfirmed = pathOr(false, ["is_confirmed"], item);
      try {
        this.confirmedLoadingList.push(id);
        await this.isConfirmedFn(item);
      } catch (error) {
        generateError(error);
        item.is_confirmed = !isConfirmed;
      } finally {
        const index = this.confirmedLoadingList.findIndex(
          (item) => item === id
        );
        if (index !== -1) {
          this.confirmedLoadingList.splice(index, 1);
        }
      }
    },
  },
};
</script>
<style>
.scrolly {
  overflow-x: scroll;
}

.table thead th {
  vertical-align: inherit;
  outline: 0;
}

.table th,
.table td {
  vertical-align: inherit;
  outline: 0;
}

.rotateY {
  transform: rotateY(180deg);
}
</style>
